export default {"src":"/_next/static/media/errorInput.d3c758f8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};